import { render, staticRenderFns } from "./RightDropdown.vue?vue&type=template&id=135923b2&scoped=true&"
import script from "./RightDropdown.vue?vue&type=script&lang=ts&"
export * from "./RightDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./RightDropdown.vue?vue&type=style&index=0&id=135923b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135923b2",
  null
  
)

export default component.exports